import React, { useState, useEffect } from "react";
import { API } from "aws-amplify";
import { awsApiCotizacionUc } from "../Services/AwsService";

import Loading from "./loading";
import ModalGeneratePdfUC from "./modalGeneratePdfUC";

import {
  cleanTablePdfUC,
  sendDataForPdfUC,
  selectResponseUC,
  cleanTablePdf,
  cleanTablePdfVAS,
} from "../Store/secureInvestmentIncome/actions";
import { addRecommended } from "../Store/recommended/actions";
import { decryptEstandar } from "../Utils/CryptographyUtils";
import { removeAll, removeAssured } from "../Store/data/actions";
import { ToastContainer, toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import ModalRetakeAsessory from "./modalRetakeAsessory";
import moment from "moment";
import HookFormUc from "./hookFormUc";
import CardFormUC from "./cardFormUC";
import IconAtomsClose from "../Resources/svg/Icons/IconAtomsClose";
import { VALOR_OPORTUNIDAD } from "../Utils/constants";

function validateValues({ valuesPdfUC }) {
  if (valuesPdfUC.length === 0) {
    return true;
  }

  if (valuesPdfUC.length > 9) {
    return false;
  } else {
    return true;
  }
}

async function handlerDataApi({
  request,
  userLogin,
  dispatch,
  values,
  assured,
  contratant,
}) {
  try {
    let response = await API.post("api-rentas", "/cotizacion", request);
    const dateNow = moment().format("YYYY-MM-DD");
    const error = false, errorMessage = "";
    if (
      response.message &&
      response.message.toLocaleUpperCase().includes(VALOR_OPORTUNIDAD)
    ) {
      return { error: true, resData: {}, errorMessage: response.message };
    }
    if (response.status === "error") {
      return { error: true, resData: {}, errorMessage };
    }

    let resData = {
      ...values,
      ...response,
      userLogin,
      dateNow,
      active: false,
      contratant,
      assured,
    };
    dispatch(sendDataForPdfUC(resData));
    dispatch(selectResponseUC(response));
    return { error, resData, errorMessage };
  } catch (e) {
    toast.error("Hubo problemas en el servidor..!!", {
      position: toast.POSITION.TOP_CENTER,
      className: "toast-modal",
    });
    return { error: true, resData: {}, errorMessage: "" };
  }
}

export default function ModalFormUC({
  open,
  close,
  id_product,
  dataState,
  idProspecto,
  investmentProfile,
  investmentPortfolio,
  portafolios,
  uuid
}) {
  const [modalDataUC, setModalDataUC] = useState({
    items: {},
    openTablePdf: false,
    showSimulate: true,
    tableSimulate: [],
    idQuote: "",
    idComponent: null,
  });

  const [isLoading, setisLoading] = useState(false);
  const [isClear, setIsClear] = useState(false);
  const [alertUC, setAlertUC] = useState(false);
  const [apiErrorMessage, setApiErrorMessage] = useState("");
  const [simbolo, setSimbolo] = useState("USD");
  const { valuesPdfUC } = useSelector((state) => state.cotizador);
  const idUser = useSelector((state) => decryptEstandar(state.login.idClient));
  const userLogin = useSelector((state) =>
    decryptEstandar(state.login.username)
  );
  const portafolio = useSelector((state) => state.cotizador.portafolio);
  const dispatch = useDispatch();
  const [openModalMessage, setOpenModalMessage] = useState(false);
  const closeModal = () => {
    close(id_product);
    setModalDataUC((prevState) => ({
      ...prevState,
      showSimulate: true,
    }));
    setApiErrorMessage("");
  };
  const openModalPdf = () =>
    setModalDataUC((prevState) => ({ ...prevState, openTablePdf: true }));
  const onCloseModalPdf = () =>
    setModalDataUC((prevState) => ({ ...prevState, openTablePdf: false }));
  const toggleSimulate = (idComponent) =>
    setModalDataUC((prevState) => ({
      ...prevState,
      showSimulate: !prevState.showSimulate,
      idComponent,
    }));

  const { items, openTablePdf, showSimulate, idComponent } = modalDataUC;
  let validate = validateValues({ valuesPdfUC });

  const verifyValuesInPdf = async (values) => {
    if (validate) {
      await getDataMacroExcel(values);
    }
  };

  useEffect(() => {
    if (validate) {
      setAlertUC(false);
    } else {
      setAlertUC(true);
    }
  }, [validate]);

  const getDataMacroExcel = async (values) => {
    setisLoading(true);
    setApiErrorMessage("");

    setModalDataUC((prevState) => ({
      ...prevState,
      items: {},
      tableSimulate: [],
    }));

    const { assured, contratant } = dataState;

    let request = awsApiCotizacionUc(
      {
        ...values,
        ...assured,
        idProspecto,
        idUser,
      },
      assured,
      contratant,
      uuid
    );

    const { error, resData, errorMessage } = await handlerDataApi({
      request,
      userLogin,
      dispatch,
      values,
      portafolio,
      assured,
      contratant,
    });
    if (!error) {
      setModalDataUC((prevState) => ({ ...prevState, items: resData }));
      setApiErrorMessage("");
    } else {
      setApiErrorMessage(errorMessage || "");
    }

    setisLoading(false);
  };

  const handleClear = () => {
    setOpenModalMessage(true);
  };

  const handleOpen = () => {
    setOpenModalMessage(false);
    closeModal();
    setIsClear(true);
    dispatch(addRecommended({}));
    dispatch(cleanTablePdfVAS());
    dispatch(cleanTablePdf());
    dispatch(cleanTablePdfUC());
  };

  const handleClose = () => {
    setOpenModalMessage(false);
  };
  useEffect(() => {
    if (isClear && Object.keys(dataState).length > 1) {
      dispatch(removeAll());
    } else if (isClear && Object.keys(dataState).length === 1) {
      dispatch(removeAssured());
    }
  }, [isClear]);

  useEffect(() => {
    if (open) {
      document.getElementsByTagName("body")[0].style.overflow = "hidden";
    } else {
      document.getElementsByTagName("body")[0].style.overflow = "auto";
    }
  }, [open]);

  return (
    <div className={`modalFormRG  ${open ? "is-open" : ""}`}>
      <div className="modalFormRG__container">
        <div className="modalFormRG__container__button" onClick={closeModal}>
          <span>Cerrar</span>
          <IconAtomsClose />
        </div>
        <HookFormUc
          dataState={dataState}
          submitValues={verifyValuesInPdf}
          openModalPdf={openModalPdf}
          onClick={() => handleClear()}
          listPortafolios={portafolios}
          investmentProfile={investmentProfile}
          investmentPortfolio={investmentPortfolio}
          isError={alertUC}
          apiError={apiErrorMessage}
          setSimbolo={setSimbolo}
          setState={setModalDataUC}
        />
        <ModalGeneratePdfUC
          open={openTablePdf}
          onCloseModalPdf={onCloseModalPdf}
          cleanTablePdfUC={cleanTablePdfUC}
        />
        <CardFormUC
          items={items}
          openModalPdf={openModalPdf}
          showSimulate={toggleSimulate}
          goTo={showSimulate}
          idComponent={idComponent}
          simbolo={simbolo}
        />
        <ToastContainer containerId={"A"} />
      </div>
      {isLoading && <Loading  />}
      <ModalRetakeAsessory
        open={openModalMessage}
        setOpen={setOpenModalMessage}
        title="¿Estas seguro?"
        subtitleMessage="Al limpiar datos perderás las cotizaciones que generaste."
        messageAlert="Si quieres volver a cotizar deberás ingresar nuevamente el número de DNI de tu cliente; la plataforma solo guardará su perfil de inversión."
        firstButtonText="CANCELAR"
        secondButtonText="CONFIRMAR"
        firstButtonFunction={handleClose}
        secondButtonFunction={handleOpen}
      />
    </div>
  );
}
